// Sunice Stacked Slider: sync + optional parallax scroll
var suniceStackedSliderScrollHandler = null;

function updateSuniceStackedSliderParallax(root) {
  const scope = root || document;
  const allSections = scope.querySelectorAll('.sunice-stacked-slider');
  allSections.forEach(function(section) {
    const slideshow = section.querySelector('slideshow-component');
    if (!slideshow) return;
    const images = slideshow.querySelectorAll('.slide__image-container img, .slide__image-container picture img, .slide__image');
    if (section.getAttribute('data-scroll-effect') === 'parallax') {
      const rect = section.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const sectionCenter = rect.top + rect.height * 0.5;
      const viewportCenter = viewportHeight * 0.5;
      var offset = (viewportCenter - sectionCenter) * 0.15;
      const visibleSlide = slideshow.querySelector('slideshow-slide:not([aria-hidden="true"])');
      const targetImages = visibleSlide ? visibleSlide.querySelectorAll('.slide__image-container img, .slide__image-container picture img, .slide__image') : images;
      targetImages.forEach(function(img) {
        img.style.transform = 'translate3d(0, ' + offset + 'px, 0)';
      });
    } else {
      images.forEach(function(img) {
        img.style.transform = '';
      });
    }
  });
}

function initSuniceStackedSliderParallax(root) {
  const sections = (root || document).querySelectorAll('.sunice-stacked-slider[data-scroll-effect="parallax"]');
  if (sections.length === 0) return;
  if (suniceStackedSliderScrollHandler) {
    window.removeEventListener('scroll', suniceStackedSliderScrollHandler, { passive: true });
  }
  suniceStackedSliderScrollHandler = function() {
    requestAnimationFrame(function() { updateSuniceStackedSliderParallax(document); });
  };
  window.addEventListener('scroll', suniceStackedSliderScrollHandler, { passive: true });
  updateSuniceStackedSliderParallax(document);
}

function initSuniceStackedSlider(root){
  const scope = root || document;
  const slideshows = scope.querySelectorAll('slideshow-component[data-current-slide]');
  slideshows.forEach(function(slideshow) {
    function updateCurrentSlide() {
      const currentIndex = slideshow.current;
      if (typeof currentIndex !== 'number') return;
      slideshow.setAttribute('data-current-slide', currentIndex);
      const benefitsSlides = slideshow.querySelectorAll('.sunice-benefits-slide');
      if (benefitsSlides.length > 0) {
        benefitsSlides.forEach((slide, index) => {
          slide.classList.toggle('active', index === currentIndex);
        });
      }
    }
    const clickHandler = function(event){
      const button = event.target.closest('button');
      if (!button || !button.hasAttribute('on:click')) return;
      const clickAction = button.getAttribute('on:click') || '';
      if (clickAction.includes('/select/') || 
          clickAction === '/next' || 
          clickAction === '/previous' ||
          clickAction === '/play' ||
          clickAction === '/pause') {
        setTimeout(function() {
        updateCurrentSlide();
        updateSuniceStackedSliderParallax(slideshow);
      }, 100);
      }
    };
    // prevent duplicate listeners
    slideshow.removeEventListener('click', clickHandler);
    slideshow.addEventListener('click', clickHandler);
    updateCurrentSlide();
    setTimeout(updateCurrentSlide, 200);
    updateSuniceStackedSliderParallax(scope);
  });
}

function setupStackedSliderThemeEditor(){
  if (!window.Shopify || !window.Shopify.designMode) return;
  document.addEventListener('shopify:section:load', (e) => {
    const id = e.detail.sectionId;
    const section = document.getElementById(`sunice-stacked-slider-${id}`)?.closest('section') || document.getElementById(`sunice-stacked-slider-${id}`);
    if (section) {
      initSuniceStackedSlider(section);
    }
  });
  document.addEventListener('shopify:block:select', (e) => {
    const id = e.detail.sectionId;
    const section = document.getElementById(`sunice-stacked-slider-${id}`)?.closest('section') || document.getElementById(`sunice-stacked-slider-${id}`);
    if (section) {
      // re-sync after block selection
      setTimeout(() => initSuniceStackedSlider(section), 50);
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initSuniceStackedSlider(document);
  initSuniceStackedSliderParallax(document);
  setupStackedSliderThemeEditor();
});
